import * as React from 'react';
import { textStyle } from './ValueChange.styles.css';

type ValueChangeProps = {
    numericChange: number;
    percentageChange: number;
    isBold?: boolean;
};

const valueChangeSymbol = (change: number) => {
    if (change > 0) return '+';
    if (change < 0) return '-';

    return '';
};

const valueChangeType = (change: number) => {
    if (change > 0) return 'positive';
    if (change < 0) return 'negative';

    return 'neutral';
};

const ValueChange: React.FC<React.PropsWithChildren<ValueChangeProps>> = ({
    numericChange,
    percentageChange,
    isBold = true,
}) => {
    const changeType = valueChangeType(percentageChange);
    const symbol = valueChangeSymbol(percentageChange);
    const change = Math.abs(numericChange).toLocaleString('en-GB');
    const percent = Math.round(Math.abs(percentageChange)).toLocaleString(
        'en-GB'
    );

    const copy = `${symbol}£${change} (${percent}%)`;

    return (
        <p
            className={textStyle({
                change: changeType,
            })}
        >
            {isBold ? <strong>{copy}</strong> : copy}
        </p>
    );
};

export default ValueChange;
